import { type ContentLanguage, type NodeAction, type NodeDesignsRevision } from "../../schemas/index.ts";
import { emptyInitialNodeDesigns } from "../reducer/index.ts";
import type { NodeDesignsState } from "../types.ts";
import type { ServerAction } from "./serverActions.ts";

export interface SendServerActionInProgress {
  action: ServerAction;
  startedAt: Date;
  /* not yet used */
  attempt: number;
}

export interface NautilusServerState {
  /* The applied revision on the server. You cannot undo to earlier than this revision. */
  revision: number;

  /* The state of node designs on the server. */
  nodeDesigns: NodeDesignsState;

  /* The revisions sent to the server but not applied to server nodeDesigns yet (so can be undone). */
  unappliedRevisions: NodeDesignsRevision[];

  /* Server actions not yet sent to the server. They are sent one by one in order (aka a FIFO queue). */
  unsentServerActions: ServerAction[];

  /* Any server action currently being sent to the server. */
  sendInProgress?: SendServerActionInProgress;
}

export interface NautilusDesignerState<AppConfig extends Record<string, unknown> = Record<string, unknown>> {
  /** The "live" state the client app runs off of. */
  nodeDesigns: NodeDesignsState;

  /** The "live" applied revisions so we can track undos optimistically */
  appliedRevisions: NodeDesignsRevision[];

  /** The node designs actions that have been applied to immediate state but not yet collected into a revision. */
  pendingRevisionActions: NodeAction[];

  /* Represents the state on the server. */
  server: NautilusServerState;

  contentLanguages: ReadonlyArray<ContentLanguage>;

  settings: {
    /** The number of revisions unapplied on the server (aka undo window). Setting supplied by and configurable on the server. */
    maxUnappliedRevisions: number;
  };

  appConfig: AppConfig;
}

export const nautilusDesignerInitialState: NautilusDesignerState = {
  nodeDesigns: emptyInitialNodeDesigns,
  appliedRevisions: [],
  pendingRevisionActions: [],
  server: {
    revision: 0,
    nodeDesigns: emptyInitialNodeDesigns,
    unappliedRevisions: [],
    unsentServerActions: [],
  },
  contentLanguages: [
    {
      language: {
        code: "en",
        title: "English",
      },
      code: "en",
      isPrimary: true,
    },
  ],
  settings: {
    maxUnappliedRevisions: 0,
  },
  appConfig: {},
};
